const messages = {
  en: {
    mediaSelection: {
      webTransfer: 'Web Transfer',
      addPics: 'Add your photos!',
      addPicsHelp: 'Tap the button below to add your photos.',
      copyright: '© 2019 FUJIFILM Corporation'
    },
    common: {
      of: 'of',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      skip: 'Skip',
      retry: 'Retry',
      retryButton: 'Retry',
      onDate: 'on',
      close: 'Close'
    },
    webTransfer: {
      termsConditions: 'Terms and Conditions Of Use',
      termsConditionsCA: 'Terms and Conditions',
      iAccept: 'I accept',
      iAcceptTC: 'I accept the Terms and Conditions',
      selectPhotos: 'Select Photos',
      privacyPolicy: 'Privacy Policy',
      tcDescription: 'Please check the box to acknowledge that by uploading my photos or otherwise using the App, I agree to the [[termsLink]] and [[privacyPolicyLink]] and that I am responsible for keeping copies of my photos.',
      tcDescriptionCA: 'Please check the box to acknowledge that by uploading my photos or otherwise using the App, I agree to the [[termsLink]], [[privacyPolicyLink]], and [[acceptableUsePolicyLink]], and that I am responsible for keeping copies of my photos.',
      filesSelected: 'files selected',
      uploadPhotos: 'Transfer Photos to Kiosk',
      startUpload: 'Start Transfer',
      retryUpload: 'Retry transferring',
      failedFile: 'failed file?',
      failedFiles: 'failed files?',
      possibleReasons: 'The internet may not be connected, or an image may be incompatible.',
      retryPrompt: 'Would you like to retry?',
      enterCodeShort: 'Enter code at the kiosk:',
      estimatedTime: 'Estimated time',
      notConnected: 'You are not connected to the internet.',
      slowConnection: 'Slow Internet Connection',
      acceptableUsePolicy: 'Acceptable Use Policy',
      contactUs: 'Contact Us',
      privacyStatement: 'Privacy Statement',
      calculating: 'Calculating...',
      connectToWifi: 'For faster photo transfer, connect your device to',
      codeInstructionTitle: 'To use the code, complete these steps on the kiosk:',
      codeInstructionStep1: 'When loading photos, select Mobile Phone.',
      codeInstructionStep2: 'Select Point & Transfer.',
      codeInstructionStep3: 'Select "use kiosk code" under step 3.',
      codeInstructionStep4: 'Enter the code shown above.'
    },
    sendCode: {
      codeExpires: 'Code expires',
      sendMeThisCode: 'Send me this code',
      sendCodeShort: 'Send code',
      howToSend: 'How would you like us to send your code?',
      errorOccurred: 'An error occurred while sending the message by ',
      email: 'Email',
      textSms: 'Text/SMS',
      emailPrompt: 'Email me this code',
      emailHelp: 'Enter your email address',
      textSmsPrompt: 'Text/SMS me this code',
      textSmsHelp: 'Enter your phone number',
      invalidEmail: 'Invalid email address',
      invalidPhone: 'Invalid phone number',
      viewPrivacy: 'View our full privacy policy',
      limitationsOfUse: 'FUJIFILM will use the information you provide here to send a link to the selected project. ',
      limitationsOfUse2: 'FUJIFILM will not use your contact information for other purposes.'
    },
    qrCode: {
      unableToUploadWithQR: 'Unable to begin a transfer with the QR code provided.',
      unexpectedProblem: 'An unexpected problem has occurred.',
      pleaseReload: 'Please reload the page and try again.',
      redirectInTen: 'You will be redirected in 10 seconds',
      redirectNow: 'Click here to be redirected now.',
      finalizingImages: 'Finalizing images....',
      photosUploaded: 'Photo Transfer Complete!',
      completeAtKiosk: 'Finish your order on the kiosk',
      addMorePhotos: 'Come back to your phone to add more photos',
      dontSeePhotos: 'Don’t see your photos on the kiosk?',
      tapHere: 'Tap here to get a code.'
    },
    safariWarning: {
      warning: 'Software Update Needed',
      explanation: 'An issue with iPhones using iOS version 18.0-18.1.1 has been reported by Apple. If you are connected to mobile data your photos will fail to upload.',
      alternativeSuggestion: 'Please try these alternatives to properly transfer your photos:',
      wifiOption: 'Connect to Walmart WiFi',
      browserOption: 'Use Chrome or another browser',
      updateOption: 'Update your iPhone to IOS 18.2 or higher',
      updateSuggestion: 'To update your phone, follow these steps:',
      updateStep1: 'Go to ',
      updateStep2: 'Select ',
      updateStep3: 'Tap on ',
      updateStep4: 'Follow the on-screen instructions to install the latest iOS software.',
      settings: 'Settings',
      general: 'General',
      softwareUpdate: 'Software Update'
    },
    help: {
      needHelp: 'Need help?',
      title: 'Photo transfer help',
      files: {
        title: 'What files are supported?',
        isOrdered: false,
        answers: [
          'jpg/jpeg',
          'png',
          'heic',
          'webp',
          'pdf'
        ]
      },
      ios: {
        questions: [
          {
            title: 'How to find files/photos on an Apple phone (iPhone)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Photo Library, Take Photo or Choose Files (your options may vary)',
              {
                title: 'From Photo Library or Choose Files, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways:',
                    answers: [
                      'Scrolling through your files',
                      'To Filter or Sort your list, tap ↑↓, then choose your option'
                    ]
                  },
                  {
                    isOrdered: false,
                    title: 'Search for your files in any of the following ways:',
                    answers: [
                      'Date (month or year)',
                      'Place (city or state)',
                      'Business names (i.e. museums)',
                      'Category (i.e. beach or sunset)',
                      'Events (i.e. sport games, concerts)',
                      'A person identified in People & pets (see Find and name people and pets)',
                      'Text (i.e. email, phone number)',
                      'Caption (see photo and video information)'
                    ]
                  }
                ]
              },
              'Once you have selected your photos, tap Add to begin the process of transferring them to the kiosk.',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      },
      android: {
        questions: [
          {
            title: 'How to find files/photos on an Android phone (i.e. Samsung / Google Pixels)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Camera or Photos & videos (your options may vary)',
              {
                title: 'From your Photos & videos, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  'Tap on three lines menu ☰ to open your files from any of the options listed in the menu.',
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways: ',
                    answers: [
                      'Scrolling through your files',
                      'To Sort your list, tap the three dots menu ⋮ to choose your option'
                    ]
                  },
                  'Use the search option to find your photos.'
                ]
              },
              'Once you have selected your photos, tap Select/Done to begin the process of transferring them to the kiosk. ',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      }
    }
  },
  es: {
    mediaSelection: {
      webTransfer: 'Transferencia web',
      addPics: '¡Agrega tus fotos!',
      addPicsHelp: 'Toca el siguiente botón para agregar tus fotos.',
      copyright: '© 2019 FUJIFILM Corporation'
    },
    common: {
      of: 'de',
      yes: 'Sí',
      no: 'No',
      ok: 'Aceptar',
      skip: 'Saltar',
      retry: 'Reintentar',
      retryButton: 'Reintentar',
      onDate: 'el',
      close: 'Cerrar'
    },
    webTransfer: {
      termsConditions: 'Términos y condiciones de uso',
      termsConditionsCA: 'Términos y condiciones',
      iAccept: 'Acepto',
      iAcceptTC: 'Acepto los/las Términos y condiciones',
      selectPhotos: 'Seleccionar fotos',
      privacyPolicy: 'Política de privacidad',
      tcDescription: 'Marque la casilla para confirmar que al subir fotos o de otra manera usar la App, acepta los [[termsLink]] y [[privacyPolicyLink]] y que usted es responsable de mantener copias de sus fotos.',
      tcDescriptionCA: 'Marque la casilla para confirmar que al subir fotos o de otra manera usar la App, acepta los [[termsLink]], [[privacyPolicyLink]], y [[acceptableUsePolicyLink]], y que usted es responsable de mantener copias de sus fotos.',
      filesSelected: 'archivos seleccionados',
      uploadPhotos: 'Transfer Photos to Kiosk',
      startUpload: 'Start Transfer',
      retryUpload: 'Retry transferring',
      failedFile: '¿Archivo fallido?',
      failedFiles: '¿Archivos fallidos?',
      possibleReasons: 'Es posible que no esté conectado a internet o que una imagen no sea compatible.',
      retryPrompt: '¿Desea volver a intentar?',
      enterCodeShort: 'Ingrese el código en el quiosco:',
      estimatedTime: 'Tiempo estimado',
      notConnected: 'Usted no está conectado a internet.',
      slowConnection: 'Slow Internet Connection',
      acceptableUsePolicy: 'Política de uso aceptable',
      contactUs: 'Contáctenos',
      privacyStatement: 'Declaración de privacidad',
      calculating: 'Calculador...',
      connectToWifi: 'Para una transferencia de fotos más rápida, conecte su dispositivo a',
      codeInstructionTitle: 'To use the code, complete these steps on the kiosk:',
      codeInstructionStep1: 'When loading photos, select Mobile Phone.',
      codeInstructionStep2: 'Select Point & Transfer.',
      codeInstructionStep3: 'Select "use kiosk code" under step 3.',
      codeInstructionStep4: 'Enter the code shown above.'
    },
    sendCode: {
      codeExpires: 'El código expira a las',
      sendMeThisCode: 'Envíeme este código',
      sendCodeShort: 'Enviar código',
      howToSend: '¿Cómo desea que le enviemos su código?',
      errorOccurred: 'Ocurrió un error mientras se enviaba el mensaje por ',
      email: 'Correo electrónico',
      textSms: 'Texto/SMS',
      emailPrompt: 'Envíeme este código por correo electrónico',
      emailHelp: 'Ingrese su dirección de correo electrónico',
      textSmsPrompt: 'Envíeme este código por texto/SMS',
      textSmsHelp: 'Ingrese su número telefónico',
      invalidEmail: 'Dirección de correo electrónica inválida',
      invalidPhone: 'Número de teléfono inválido',
      viewPrivacy: 'Vea nuestra política de privacidad completa',
      limitationsOfUse: 'FUJIFILM usará la información que proporcionó aquí para enviar un enlace al proyecto seleccionado. ',
      limitationsOfUse2: 'FUJIFILM no usará su información de contacto para otros fines.'
    },
    qrCode: {
      unableToUploadWithQR: 'Unable to begin a transfer with the QR code provided.',
      unexpectedProblem: 'Ha ocurrido un problema inesperado.',
      pleaseReload: 'Vuelve a cargar la página e inténtalo de nuevo.',
      redirectInTen: 'Será redirigido en 10 segundos.',
      redirectNow: 'Haga clic aquí para ser redirigido ahora.',
      finalizingImages: 'Finalizando imágenes....',
      photosUploaded: 'Photo Transfer Complete!',
      completeAtKiosk: 'Finish your order on the kiosk',
      addMorePhotos: 'Vuelve a tu teléfono para agregar más fotos.',
      dontSeePhotos: 'Don’t see your photos on the kiosk?',
      tapHere: 'Tap here to get a code.'
    },
    safariWarning: {
      warning: 'Software Update Needed',
      explanation: 'An issue with iPhones using iOS version 18.0-18.1.1 has been reported by Apple. If you are connected to mobile data your photos will fail to upload.',
      alternativeSuggestion: 'Please try these alternatives to properly transfer your photos:',
      wifiOption: 'Connect to Walmart WiFi',
      browserOption: 'Use Chrome or another browser',
      updateOption: 'Update your iPhone to IOS 18.2 or higher',
      updateSuggestion: 'To update your phone, follow these steps:',
      updateStep1: 'Go to ',
      updateStep2: 'Select ',
      updateStep3: 'Tap on ',
      updateStep4: 'Follow the on-screen instructions to install the latest iOS software.',
      settings: 'Settings',
      general: 'General',
      softwareUpdate: 'Software Update'
    },
    help: {
      needHelp: 'Need help?',
      title: 'Photo transfer help',
      files: {
        title: 'What files are supported?',
        isOrdered: false,
        answers: [
          'jpg/jpeg',
          'png',
          'heic',
          'webp',
          'pdf'
        ]
      },
      ios: {
        questions: [
          {
            title: 'How to find files/photos on an Apple phone (iPhone)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Photo Library, Take Photo or Choose Files (your options may vary)',
              {
                title: 'From Photo Library or Choose Files, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways:',
                    answers: [
                      'Scrolling through your files',
                      'To Filter or Sort your list, tap ↑↓, then choose your option'
                    ]
                  },
                  {
                    isOrdered: false,
                    title: 'Search for your files in any of the following ways:',
                    answers: [
                      'Date (month or year)',
                      'Place (city or state)',
                      'Business names (i.e. museums)',
                      'Category (i.e. beach or sunset)',
                      'Events (i.e. sport games, concerts)',
                      'A person identified in People & pets (see Find and name people and pets)',
                      'Text (i.e. email, phone number)',
                      'Caption (see photo and video information)'
                    ]
                  }
                ]
              },
              'Once you have selected your photos, tap Add to begin the process of transferring them to the kiosk.',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      },
      android: {
        questions: [
          {
            title: 'How to find files/photos on an Android phone (i.e. Samsung / Google Pixels)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Camera or Photos & videos (your options may vary)',
              {
                title: 'From your Photos & videos, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  'Tap on three lines menu ☰ to open your files from any of the options listed in the menu.',
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways: ',
                    answers: [
                      'Scrolling through your files',
                      'To Sort your list, tap the three dots menu ⋮ to choose your option'
                    ]
                  },
                  'Use the search option to find your photos.'
                ]
              },
              'Once you have selected your photos, tap Select/Done to begin the process of transferring them to the kiosk. ',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      }
    }
  },
  pt: {
    mediaSelection: {
      webTransfer: 'Transferência on-line',
      addPics: 'Adicione suas fotos!',
      addPicsHelp: 'Toque no botão abaixo para adicionar suas fotos.',
      copyright: '© 2019 FUJIFILM Corporation'
    },
    common: {
      of: 'de',
      yes: 'Sim',
      no: 'Não',
      ok: 'OK',
      skip: 'Pular',
      retry: 'Tentar novamente',
      retryButton: 'Tentar novamente',
      onDate: 'de',
      close: 'Fechar'
    },
    webTransfer: {
      termsConditions: 'Termos e condições de uso',
      termsConditionsCA: 'Termos e condições',
      iAccept: 'Eu aceito',
      iAcceptTC: 'Eu aceito os(as) Termos e condições',
      selectPhotos: 'Selecionar fotos',
      privacyPolicy: 'Política de privacidade',
      tcDescription: 'Marque a caixa para confirmar que ao carregar suas fotos ou usar o aplicativo, você concorda com os [[termsLink]] e [[privacyPolicyLink]] e que você é responsável por manter cópias de suas fotos.',
      tcDescriptionCA: 'Marque a caixa para confirmar que ao carregar suas fotos ou usar o aplicativo, você concorda com os [[termsLink]], [[privacyPolicyLink]], e [[acceptableUsePolicyLink]], e que você é responsável por manter cópias de suas fotos.',
      filesSelected: 'arquivos selecionados',
      uploadPhotos: 'Transfer Photos to Kiosk',
      startUpload: 'Start Transfer',
      retryUpload: 'Retry transferring',
      failedFile: 'arquivo falho?',
      failedFiles: 'arquivos falhos?',
      possibleReasons: 'Pode ter havido uma falha na conexão com a Internet ou a imagem pode não ser compatível.',
      retryPrompt: 'Gostaria de tentar novamente?',
      enterCodeShort: 'Digite o código no kiosk:',
      estimatedTime: 'Tempo estimado',
      notConnected: 'Você não está conectado à Internet.',
      slowConnection: 'Slow Internet Connection',
      acceptableUsePolicy: 'Política de uso aceitável',
      contactUs: 'Contate-nos',
      privacyStatement: 'Declaração de privacidade',
      calculating: 'Calculando...',
      connectToWifi: 'Para uma transferência de fotos mais rápida, conecte seu dispositivo ao',
      codeInstructionTitle: 'To use the code, complete these steps on the kiosk:',
      codeInstructionStep1: 'When loading photos, select Mobile Phone.',
      codeInstructionStep2: 'Select Point & Transfer.',
      codeInstructionStep3: 'Select "use kiosk code" under step 3.',
      codeInstructionStep4: 'Enter the code shown above.'
    },
    sendCode: {
      codeExpires: 'O código é válido até as',
      sendMeThisCode: 'Envie-me este código',
      sendCodeShort: 'Enviar código',
      howToSend: 'De que forma você deseja que o código seja enviado?',
      errorOccurred: 'Ocorreu um erro durante o envio da mensagem por ',
      email: 'E-mail',
      textSms: 'Mensagem de texto/SMS',
      emailPrompt: 'Enviar este código por e-mail',
      emailHelp: 'Digite seu e-mail',
      textSmsPrompt: 'Enviar este código por mensagem de texto/SMS',
      textSmsHelp: 'Digite seu número de telefone',
      invalidEmail: 'E-mail inválido',
      invalidPhone: 'Número de telefone inválido',
      viewPrivacy: 'Acessar nossa política de privacidade na íntegra',
      limitationsOfUse: 'A FUJIFILM usará as informações que você nos forneceu para enviar um link de acesso ao projeto selecionado. ',
      limitationsOfUse2: 'A FUJIFILM não usará suas informações de contato para outros fins.'
    },
    qrCode: {
      unableToUploadWithQR: 'Unable to begin a transfer with the QR code provided.',
      unexpectedProblem: 'Ocorreu um problema inesperado.',
      pleaseReload: 'Por favor, recarregue a página e tente denovo.',
      redirectInTen: 'You will be redirected in 10 seconds',
      redirectNow: 'Você será redirecionado em 10 segundos',
      finalizingImages: 'Finalizando imagens....',
      photosUploaded: 'Photo Transfer Complete!',
      completeAtKiosk: 'Finish your order on the kiosk',
      addMorePhotos: 'Volte ao seu telefone para adicionar mais fotos',
      dontSeePhotos: 'Don’t see your photos on the kiosk?',
      tapHere: 'Tap here to get a code.'
    },
    safariWarning: {
      warning: 'Software Update Needed',
      explanation: 'An issue with iPhones using iOS version 18.0-18.1.1 has been reported by Apple. If you are connected to mobile data your photos will fail to upload.',
      alternativeSuggestion: 'Please try these alternatives to properly transfer your photos:',
      wifiOption: 'Connect to Walmart WiFi',
      browserOption: 'Use Chrome or another browser',
      updateOption: 'Update your iPhone to IOS 18.2 or higher',
      updateSuggestion: 'To update your phone, follow these steps:',
      updateStep1: 'Go to ',
      updateStep2: 'Select ',
      updateStep3: 'Tap on ',
      updateStep4: 'Follow the on-screen instructions to install the latest iOS software.',
      settings: 'Settings',
      general: 'General',
      softwareUpdate: 'Software Update'
    },
    help: {
      needHelp: 'Need help?',
      title: 'Photo transfer help',
      files: {
        title: 'What files are supported?',
        isOrdered: false,
        answers: [
          'jpg/jpeg',
          'png',
          'heic',
          'webp',
          'pdf'
        ]
      },
      ios: {
        questions: [
          {
            title: 'How to find files/photos on an Apple phone (iPhone)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Photo Library, Take Photo or Choose Files (your options may vary)',
              {
                title: 'From Photo Library or Choose Files, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways:',
                    answers: [
                      'Scrolling through your files',
                      'To Filter or Sort your list, tap ↑↓, then choose your option'
                    ]
                  },
                  {
                    isOrdered: false,
                    title: 'Search for your files in any of the following ways:',
                    answers: [
                      'Date (month or year)',
                      'Place (city or state)',
                      'Business names (i.e. museums)',
                      'Category (i.e. beach or sunset)',
                      'Events (i.e. sport games, concerts)',
                      'A person identified in People & pets (see Find and name people and pets)',
                      'Text (i.e. email, phone number)',
                      'Caption (see photo and video information)'
                    ]
                  }
                ]
              },
              'Once you have selected your photos, tap Add to begin the process of transferring them to the kiosk.',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      },
      android: {
        questions: [
          {
            title: 'How to find files/photos on an Android phone (i.e. Samsung / Google Pixels)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Camera or Photos & videos (your options may vary)',
              {
                title: 'From your Photos & videos, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  'Tap on three lines menu ☰ to open your files from any of the options listed in the menu.',
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways: ',
                    answers: [
                      'Scrolling through your files',
                      'To Sort your list, tap the three dots menu ⋮ to choose your option'
                    ]
                  },
                  'Use the search option to find your photos.'
                ]
              },
              'Once you have selected your photos, tap Select/Done to begin the process of transferring them to the kiosk. ',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      }
    }
  },
  fr: {
    mediaSelection: {
      webTransfer: 'Transfert Web',
      addPics: 'Ajoutez vos photos!',
      addPicsHelp: 'Appuyez sur le bouton ci-dessous pour ajouter vos photos.',
      copyright: '© 2019 FUJIFILM Corporation'
    },
    common: {
      of: 'de',
      yes: 'Oui',
      no: 'Non',
      ok: 'OK',
      skip: 'Sauter',
      retry: 'Réessayer',
      retryButton: 'Réessayer',
      onDate: 'le',
      close: 'Fermer'
    },
    webTransfer: {
      termsConditions: 'Conditions générales d’utilisation',
      termsConditionsCA: 'Conditions générales',
      iAccept: 'J’accepte',
      iAcceptTC: 'J’accepte les Conditions générales',
      selectPhotos: 'Sélectionner des photos',
      privacyPolicy: 'Politique de confidentialité',
      tcDescription: 'Veuillez cocher la case pour signifier qu’en téléversant vos photos ou en utilisant d’une autre manière l’Application, vous acceptez les [[termsLink]] et [[privacyPolicyLink]] et vous êtes responsable de conserver des copies de vos photos.',
      tcDescriptionCA: 'Veuillez cocher la case pour signifier qu’en téléversant vos photos ou en utilisant d’une autre manière l’Application, vous acceptez les [[termsLink]], [[privacyPolicyLink]], et [[acceptableUsePolicyLink]], et vous êtes responsable de conserver des copies de vos photos.',
      filesSelected: 'fichiers sélectionnés',
      uploadPhotos: 'Transfer Photos to Kiosk',
      startUpload: 'Start Transfer',
      retryUpload: 'Retry transferring',
      failedFile: 'fichier en échec?',
      failedFiles: 'fichiers en échec?',
      possibleReasons: 'La connexion Internet peut être rompue ou une image peut être incompatible.',
      retryPrompt: 'Voulez-vous réessayer?',
      enterCodeShort: 'Entrez le code au kiosque :',
      estimatedTime: 'Temps estimé',
      notConnected: 'Vous n’avez aucune connexion à Internet.',
      slowConnection: 'Slow Internet Connection',
      acceptableUsePolicy: 'Politique sur l’utilisation acceptable',
      contactUs: 'Communiquez avec nous',
      privacyStatement: 'Déclaration de confidentialité',
      calculating: 'Calculateur...',
      connectToWifi: 'Pour un transfert de photos plus rapide, connectez votre appareil à',
      codeInstructionTitle: 'To use the code, complete these steps on the kiosk:',
      codeInstructionStep1: 'When loading photos, select Mobile Phone.',
      codeInstructionStep2: 'Select Point & Transfer.',
      codeInstructionStep3: 'Select "use kiosk code" under step 3.',
      codeInstructionStep4: 'Enter the code shown above.'
    },
    sendCode: {
      codeExpires: 'Code expire à',
      sendMeThisCode: 'Envoyez-moi ce code',
      sendCodeShort: 'Envoyer le code',
      howToSend: 'Comment voulez-vous que nous vous envoyions votre code?',
      errorOccurred: 'Une erreur s’est produite en envoyant le message par ',
      email: 'Courriel',
      textSms: 'Messagerie texte (SMS)',
      emailPrompt: 'Envoyez-moi ce code par courriel',
      emailHelp: 'Entrez votre adresse de courriel',
      textSmsPrompt: 'Envoyez-moi ce code par message texte',
      textSmsHelp: 'Entrez votre numéro de téléphone',
      invalidEmail: 'Adresse de courriel non valide',
      invalidPhone: 'Numéro de téléphone non valide',
      viewPrivacy: 'Consultez notre politique complète de confidentialité',
      limitationsOfUse: 'FUJIFILM utilisera l’information que vous fournissez ici pour envoyer un lien vers le projet sélectionné. ',
      limitationsOfUse2: 'FUJIFILM n’utilisera pas vos coordonnées à d’autres fins.'
    },
    qrCode: {
      unableToUploadWithQR: 'Unable to begin a transfer with the QR code provided.',
      unexpectedProblem: 'An unexpected problem has occurred.',
      pleaseReload: 'Un problème inattendu s’est produit.',
      redirectInTen: 'Vous serez redirigé dans 10 secondes',
      redirectNow: 'Cliquez ici pour être redirigé maintenant.',
      finalizingImages: 'Finalisation des images....',
      photosUploaded: 'Photo Transfer Complete!',
      completeAtKiosk: 'Finish your order on the kiosk',
      addMorePhotos: 'Revenez sur votre téléphone pour ajouter d’autres photos',
      dontSeePhotos: 'Don’t see your photos on the kiosk?',
      tapHere: 'Tap here to get a code.'
    },
    safariWarning: {
      warning: 'Software Update Needed',
      explanation: 'An issue with iPhones using iOS version 18.0-18.1.1 has been reported by Apple. If you are connected to mobile data your photos will fail to upload.',
      alternativeSuggestion: 'Please try these alternatives to properly transfer your photos:',
      wifiOption: 'Connect to Walmart WiFi',
      browserOption: 'Use Chrome or another browser',
      updateOption: 'Update your iPhone to IOS 18.2 or higher',
      updateSuggestion: 'To update your phone, follow these steps:',
      updateStep1: 'Go to ',
      updateStep2: 'Select ',
      updateStep3: 'Tap on ',
      updateStep4: 'Follow the on-screen instructions to install the latest iOS software.',
      settings: 'Settings',
      general: 'General',
      softwareUpdate: 'Software Update'
    },
    help: {
      needHelp: 'Need help?',
      title: 'Photo transfer help',
      files: {
        title: 'What files are supported?',
        isOrdered: false,
        answers: [
          'jpg/jpeg',
          'png',
          'heic',
          'webp',
          'pdf'
        ]
      },
      ios: {
        questions: [
          {
            title: 'How to find files/photos on an Apple phone (iPhone)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Photo Library, Take Photo or Choose Files (your options may vary)',
              {
                title: 'From Photo Library or Choose Files, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways:',
                    answers: [
                      'Scrolling through your files',
                      'To Filter or Sort your list, tap ↑↓, then choose your option'
                    ]
                  },
                  {
                    isOrdered: false,
                    title: 'Search for your files in any of the following ways:',
                    answers: [
                      'Date (month or year)',
                      'Place (city or state)',
                      'Business names (i.e. museums)',
                      'Category (i.e. beach or sunset)',
                      'Events (i.e. sport games, concerts)',
                      'A person identified in People & pets (see Find and name people and pets)',
                      'Text (i.e. email, phone number)',
                      'Caption (see photo and video information)'
                    ]
                  }
                ]
              },
              'Once you have selected your photos, tap Add to begin the process of transferring them to the kiosk.',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      },
      android: {
        questions: [
          {
            title: 'How to find files/photos on an Android phone (i.e. Samsung / Google Pixels)?',
            isOrdered: true,
            answers: [
              'Once you tap on SELECT PHOTOS, you will be able to select from Camera or Photos & videos (your options may vary)',
              {
                title: 'From your Photos & videos, you can find files in any of the following ways:',
                isOrdered: false,
                answers: [
                  'Tap on three lines menu ☰ to open your files from any of the options listed in the menu.',
                  {
                    isOrdered: false,
                    title: 'Browse for your files in any of the following ways: ',
                    answers: [
                      'Scrolling through your files',
                      'To Sort your list, tap the three dots menu ⋮ to choose your option'
                    ]
                  },
                  'Use the search option to find your photos.'
                ]
              },
              'Once you have selected your photos, tap Select/Done to begin the process of transferring them to the kiosk. ',
              'Follow the on-screen instructions on your phone to complete the transfer of your photos to the kiosk.'
            ]
          }
        ]
      }
    }
  }
}

export default {
  messages
}
